import { render, staticRenderFns } from "./GuideRestaurants.vue?vue&type=template&id=527d833b"
import script from "./GuideRestaurants.vue?vue&type=script&lang=js"
export * from "./GuideRestaurants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports